function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.6 9.848H15c.6 0 1 .419 1 1.047v10.057c0 .629-.4 1.048-1 1.048H1c-.552 0-1-.469-1-1.048V10.895c0-.628.4-1.047 1-1.047h1.4v-4.19h2.2v4.19h6.8v-4.19h2.2v4.19zm0-4.19H2.4C2.4 2.513 5 0 8 0c3 0 5.6 2.514 5.6 5.657zm-2.2 0C11.4 3.77 9.9 2.2 8 2.2c-1.84 0-3.346 1.531-3.4 3.457h6.8z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 22
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/waitlist.8fdb0e2f.svg";
export { SvgComponent as ReactComponent };